/* import __COLOCATED_TEMPLATE__ from './canvas.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();